import React, {useLayoutEffect, useRef} from 'react';
import NumberFormat from "react-number-format";
import PropTypes from "prop-types";
import InputMask from "react-input-mask";
import {formatarCentavos, proximoValorMonetario, valorParaCentavos} from "../../../utils";

export const DDDNumberFormatCustom = props => {
    const {
        inputRef,
        onChange,
        ...other
    } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                const {formattedValue, value} = values;

                onChange({
                    target: {
                        name: props.name,
                        value: formattedValue,
                    }
                });
            }}
            format='###'
            mask={''} />
    );
};

DDDNumberFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export const CpfNumberFormatCustom = props => {
    const {
        inputRef,
        onChange,
        ...other
    } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                const {formattedValue, value} = values;

                onChange({
                    target: {
                        name: props.name,
                        value: formattedValue,
                    }
                });
            }}
            placeholder='___.___.___-__'
            format='###.###.###-##'
            mask={'_'} />
    );
};

CpfNumberFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export const CnpjNumberFormatCustom = props => {
    const {
        inputRef,
        onChange,
        ...other
    } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                const {formattedValue, value} = values;

                onChange({
                    target: {
                        name: props.name,
                        value: formattedValue,
                    }
                });
            }}
            placeholder='__.___.___/____-__'
            format='##.###.###/####-##'
            mask={'_'} />
    );
};

CnpjNumberFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export const RgNumberFormatCustom = props => {
    const {
        onChange,
        inputRef, // Colocado aqui apenas para não ser adicionado ao InputMask, pois não existe esse atributo no componte.,
        ...other
    } = props;

    return (
        <InputMask
            mask="99.999.999-*"
            onChange={onChange}
            {...other} />
    );
};

RgNumberFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export const CepNumberFormatCustom = props => {
    const {
        inputRef,
        onChange,
        ...other
    } = props;

    return (
        <InputMask
            mask="99999-999"
            onChange={onChange}
            {...other} />
    );
};

CepNumberFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export const DataNascimentoNumberFormatCustom = props => {
    const {
        inputRef,
        onChange,
        ...other
    } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                const {formattedValue, value} = values;

                onChange({
                    target: {
                        name: props.name,
                        value: formattedValue,
                    }
                });
            }}
            placeholder='__/__/____'
            format='##/##/####'
            mask={'_'} />
    );
};

DataNascimentoNumberFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export const TelefoneNumberFormatCustom = props => {
    const {
        onChange,
        inputRef, // Colocado aqui apenas para não ser adicionado ao InputMask, pois não existe esse atributo no componte.
        ...other
    } = props;

    return (
        <InputMask
            mask="(99) 9999-9999"
            onChange={onChange}
            {...other} />
    );
};

TelefoneNumberFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export const CelularNumberFormatCustom = props => {
    const {
        onChange,
        inputRef, // Colocado aqui apenas para não ser adicionado ao InputMask, pois não existe esse atributo no componte.
        ...other
    } = props;

    return (
        <InputMask
            mask="(99) 99999-9999"
            onChange={onChange}
            {...other} />
    );
};

CelularNumberFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

// Dinheiro estilo banco: digita da esquerda para a direita e o dígito novo sempre entra no fim (500000 → 5.000,00).
// Emite o valor em reais como número, ou '' quando o campo fica vazio.
export const ValorMonetarioNumberFormatCustom = props => {
    const {
        inputRef,
        onChange,
        value,
        name,
        onFocus,
        onClick,
        onKeyUp,
        ...other
    } = props;

    const elemento = useRef(null);
    const texto = formatarCentavos(valorParaCentavos(value));

    const definirElemento = (el) => {
        elemento.current = el;
        if (typeof inputRef === 'function') inputRef(el);
        else if (inputRef) inputRef.current = el;
    };

    const levarCursorAoFim = (el) => {
        if (!el || document.activeElement !== el) return;
        const tudoSelecionado = el.selectionStart === 0 && el.selectionEnd === el.value.length && el.value.length > 0;
        if (tudoSelecionado) return;
        const fim = el.value.length;
        el.setSelectionRange(fim, fim);
    };

    useLayoutEffect(() => {
        levarCursorAoFim(elemento.current);
    }, [texto]);

    const encadear = (handler) => (evento) => {
        if (handler) handler(evento);
        levarCursorAoFim(evento.target);
    };

    return (
        <input
            {...other}
            ref={definirElemento}
            name={name}
            value={texto}
            inputMode="numeric"
            autoComplete="off"
            onChange={(evento) => onChange({
                target: {
                    name,
                    value: proximoValorMonetario(evento.target.value, value),
                }
            })}
            onFocus={encadear(onFocus)}
            onClick={encadear(onClick)}
            onKeyUp={encadear(onKeyUp)} />
    );
}

ValorMonetarioNumberFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};